import { ApiService } from "../api.service";
import { Customer } from "@/models/entities/customer/customer.interface";
import { CustomerUpdate } from "@/models/entities/customer/customerUpdate/customerUpdate.interface";
import { ExcludeCustomers } from "@/models/entities/customer/excludeCustomers/excludeCustomers.interface";

const CONTROLLER = "users";

class CustomerService extends ApiService {
  getCustomers(codice: string, ragioneSociale: string) {
    return this.getAll<Customer[]>(
      `${CONTROLLER}/getall/?codice=${codice}&ragioneSociale=${ragioneSociale}`
    );
  }

  updateCustomer(values: CustomerUpdate) {
    return this.post<CustomerUpdate, CustomerUpdate>(`${CONTROLLER}`, values);
  }

  excludeCustomer(values: ExcludeCustomers) {
    return this.post<ExcludeCustomers, ExcludeCustomers>(
      "/excludecustomers/saveclicked",
      values
    );
  }
}

export const customerService = new CustomerService();
